<template>
  <div>
    <UsuarioDialog @closeModal="loadUsuarios" />
    <v-card>
      <v-card-title>
        <v-icon left color="primary">lock</v-icon>Cadastro de Usuários
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Pesquisar pelo Nome ou email"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="usuarios"
          class="elevation-1"
          :loading="loading"
          disable-pagination
          hide-default-footer
          @click:row="usuarioSelected"
        >
          <template v-slot:[`item.admin`]="{ item }">
            <v-icon color="success" v-if="item.admin"
              >check_circle_outline</v-icon
            >
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <v-icon color="success" v-if="item.ativo"
              >check_circle_outline</v-icon
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapMutations, mapActions } from "vuex";
import UsuarioDialog from "../components/usuarios/UsuarioDialog";

export default {
  components: { UsuarioDialog },
  data: function () {
    return {
      search: "",
      usuarios: [],
      headers: [
        { text: "Nome", value: "nome" },
        { text: "E-mail", value: "email" },
        { text: "Cidade", value: "cidade" },
        { text: "Admin", value: "admin" },
        { text: "Ativo", value: "ativo" },
      ],
      loading: false,
    };
  },
  methods: {
    ...mapMutations("usuarios", ["setUsuario"]),
    ...mapActions("usuarios", ["showDialog"]),
    async loadUsuarios() {
      try {
        this.loading = true;
        const response = await this.axios.get("/usuarios", {
          params: { search: this.search },
        });
        this.usuarios = response.data;
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
    usuarioSelected(usuario) {
      this.setUsuario({ ...usuario });
      this.showDialog();
    },
  },
  mounted() {
    this.loadUsuarios();
  },
  watch: {
    search() {
      this.loadUsuarios();
    },
  },
};
</script>